import { restHeartClient } from '@/network'

/**
 *
 * @param db
 * @param collection
 * @param fileId
 */
export const getFileBinary = (db: string, collection: string, fileId: string) => {
	return `${restHeartClient.defaults.baseURL}/${db}/${collection}.files/${fileId}/binary`
}
